import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Download, X } from "lucide-react";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("install-dismissed")) return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setOpen(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    setOpen(false);
    setDeferred(null);
  };

  const dismiss = () => {
    sessionStorage.setItem("install-dismissed", "1");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="install-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          className="glass fixed inset-x-4 bottom-4 z-50 flex items-center gap-3 rounded-2xl border-amber-500/30 p-4 shadow-[0_0_50px_rgba(212,175,55,0.15)] sm:left-auto sm:w-96"
        >
          <img src="/icon-192.png" alt="سکه کازرانی" className="h-12 w-12 shrink-0 rounded-xl" />
          <div className="min-w-0 flex-1">
            <div className="text-sm font-bold text-amber-100">اپلیکیشن سکه کازرانی</div>
            <div className="mt-0.5 text-[11px] leading-5 text-stone-400">برای دسترسی سریع به نرخ روز، روی صفحه اصلی گوشی نصب کنید</div>
          </div>
          <button
            data-testid="install-confirm-btn"
            onClick={install}
            className="flex shrink-0 items-center gap-1.5 rounded-full bg-amber-500 px-4 py-2 text-xs font-bold text-black transition-colors hover:bg-amber-400"
          >
            <Download className="h-3.5 w-3.5" />
            نصب
          </button>
          <button data-testid="install-dismiss-btn" onClick={dismiss} aria-label="بستن" className="shrink-0 text-stone-500 transition-colors hover:text-stone-300">
            <X className="h-4 w-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
